/**
 * Internal dependencies
 */
import getCurrentUserId from './get-current-user-id';

export default (state) => !!getCurrentUserId(state);
